<div class="d-flex flex-wrap staff-table-filter">
    <div class="mr-3 mb-3">
        <input [(ngModel)]="filterText" 
        name="filterText" 
        (keyup)="refresh()" 
        (blur)="refresh()" 
        autoFocus
        class="form-control m-input" 
        [placeholder]="l('SearchNameWithThreeDot')" 
        type="text">
    </div>
    <div class="mr-3 mb-3">
        <button class="btn btn-default btn-inverted" (click)="staffRoleSelector.open()">
            {{ l("StaffRole") }}
        </button>

        <div class="filter-button">
            <mat-form-field>
                <mat-select [formControl]="staffRoleFormCtrl" [multiple]="false" #staffRoleSelector>
                    <mat-option>
                        <ngx-mat-select-search noEntriesFoundLabel="No results found"
                            placeholderLabel="Search by Role..." [formControl]="staffRoleFilterFormCtrl">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let staffRole of filteredStaffRole | async" [value]="staffRole"
                        (click)="refresh()" #option>
                        {{l(staffRole.staffRoleDisplayName)}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <!-- <div class="mr-3 mb-3">
        <button class="btn btn-default btn-inverted" (click)="jobTitleSelector.open()">
            {{ l("JobTitle") }}
        </button>

        <div class="filter-button">
            <mat-form-field>
                <mat-select [formControl]="jobTitleFormCtrl" [multiple]="false" #jobTitleSelector>
                    <mat-option>
                        <ngx-mat-select-search noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a jobTitle..." [formControl]="jobTitleFilterFormCtrl">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let jobTitle of filteredJobTitle | async" [value]="jobTitle" (click)="refresh()"
                        #option>
                        {{ jobTitle.jobTitle }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div> -->

    <div class="mr-3 mb-3">
        <button class="btn btn-default btn-inverted" (click)="companySelector.open()">
            {{ l("Company") }}
        </button>

        <div class="filter-button">
            <mat-form-field>
                <mat-select [formControl]="companyFormCtrl" [multiple]="false" #companySelector>
                    <mat-option>
                        <ngx-mat-select-search noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a company..." [formControl]="companyFilterFormCtrl">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let company of filteredCompany | async" [value]="company" (click)="refresh()"
                        #option>
                        {{ company.company }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="mr-3 mb-3">
        <button class="btn btn-link link-grey" (click)="clear()">
            {{ l("Clear") }}
        </button>
    </div>
</div>
<div class="d-flex flex-wrap filter" *ngIf='filterText 
    || (staffRoleFormCtrl.value && staffRoleFormCtrl.value.staffRole) || 
    (companyFormCtrl.value && companyFormCtrl.value.company)'>
    {{ l("Filter") }}:
    <ng-container *ngIf='filterText'> {{ l("Search") }} - {{filterText}},</ng-container>
    <ng-container *ngIf='staffRoleFormCtrl.value && staffRoleFormCtrl.value.staffRoleName'> {{ l("StaffRole") }} -
        {{l(staffRoleFormCtrl.value.staffRoleName)}},</ng-container>
    <ng-container *ngIf='companyFormCtrl.value && companyFormCtrl.value.company'> {{ l("Company") }} -
        {{companyFormCtrl.value.company}},</ng-container>
</div>